import watchState from "./watch-state.js";
import createState from "./create-state.js";
import stateObserver from "./state-observer.js";
import updateAttributes from "./update-attributes.js";

const state = {
	watchState,
	createState,
	stateObserver,
	updateAttributes,
};

export default state;
